import { IInitialState } from 'store/models';
import { templatesStateSelector } from './templatesStateSelector';

export function isLoadingSelector(state: IInitialState) {
	return templatesStateSelector(state)?.isLoading;
}
